import { SERVICES } from "../../lib/site";
import SectionHeader from "../SectionHeader";
import {
  Compass,
  Wrench,
  Settings2,
  Users2,
  LayoutDashboard,
} from "lucide-react";

const ICONS = {
  Consulting: Compass,
  "Makerspace Setup": Wrench,
  "Equipment Training": Settings2,
  "Facilitator Development": Users2,
  Platform: LayoutDashboard,
};

export default function WhatWeDo() {
  return (
    <section
      data-testid="what-we-do-section"
      className="bg-[#F8F9FA] border-y-2 border-[#1A1A1A] relative overflow-hidden"
    >
      <div className="absolute inset-0 bg-grid opacity-50 pointer-events-none" />
      <div className="relative mx-auto max-w-7xl px-5 md:px-10 lg:px-12 py-20 md:py-28">
        <SectionHeader
          eyebrow="What We Do"
          accent="#FF6600"
          title={
            <>
              We help you move from{" "}
              <span className="underline decoration-[#FF6600] decoration-[6px] underline-offset-4">
                ideas
              </span>{" "}
              to implementation.
            </>
          }
          intro="Five practical ways we partner with schools, libraries and councils to turn future-ready intent into running programs."
        />

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-7">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.title];
            return (
              <div
                key={s.title}
                data-testid={`service-card-${s.title.toLowerCase().replace(/\s+|\+/g, "-")}`}
                style={{ backgroundColor: s.color, color: s.text }}
                className={`relative rounded-3xl nb-border-thick nb-shadow p-7 md:p-8 nb-lift overflow-hidden
                  ${i === 1 ? "lg:translate-y-8" : ""}
                  ${i === 3 ? "lg:-translate-y-4" : ""}
                  ${i === 4 ? "md:col-span-2 lg:col-span-1 lg:translate-y-6" : ""}
                `}
              >
                {s.badge && (
                  <span className="absolute top-5 right-5 inline-flex items-center gap-1 bg-white text-[#1A1A1A] border-2 border-[#1A1A1A] rounded-full px-3 py-1 text-[10px] font-mono uppercase tracking-widest nb-shadow-sm">
                    {s.badge}
                  </span>
                )}
                <div className="h-14 w-14 rounded-2xl bg-white text-[#1A1A1A] border-2 border-[#1A1A1A] flex items-center justify-center nb-shadow-sm">
                  {Icon && <Icon size={26} strokeWidth={2.5} />}
                </div>
                <h3 className="mt-6 font-display font-black text-2xl md:text-3xl leading-tight tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm md:text-base font-semibold leading-relaxed opacity-95">
                  {s.blurb}
                </p>
                <span className="absolute -bottom-8 -right-8 font-display font-black text-[8rem] leading-none opacity-10">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
